export const header = {
    "question_for_representative": "שאלה לנציג"
};
